<template>
  <div class="content">

   <!-- <router-view></router-view> -->

    <!-- 大图banner -->
    <div class="home-banner">
      <!-- <img :src="img" alt=""> -->
    <el-carousel height="6rem" :autoplay="true" :interval="2000" arrow="never">
    <el-carousel-item v-for="(item,index) in bannerimgs" :key="item.id">
      <div class="banner-a">

         <img :src="'http://ke.yunlearning.com:8081'+bannerimgs[index].img" alt="">


      </div>
    </el-carousel-item>
  </el-carousel>
    </div>


  <div class="xiazai">
      <div class="left">
        <img src="../images/方案 (1).png" alt="" style="margin-bottom:10px">

        <p style="margin-bottom:10px">竞赛方案</p>

        <div class="download"><a href="http://ke.yunlearning.com:8081/wenjian/微课大赛竞赛方案.docx">下载文件</a></div>
      </div>
     <div class="left">
        <img src="../images/标准.png" alt="" style="margin-bottom:10px">

        <p style="margin-bottom:10px">技术规范</p>

        <div class="download"><a href="http://ke.yunlearning.com:8081/wenjian/微课大赛微课制作技术规范.docx">下载文件</a></div>
      </div>
<div class="left">
        <img src="../images/报名 (1).png" alt="" style="margin-bottom:10px">

        <p style="margin-bottom:10px">报名表</p>

        <div class="download"><a href="http://ke.yunlearning.com:8081/wenjian/参赛报名表.docx">下载文件</a></div>
      </div>
      <div class="left">
        <img src="../images/标准.png" alt="" style="margin-bottom:10px">

        <p style="margin-bottom:10px">评分标准</p>

        <div class="download"><a href="http://ke.yunlearning.com:8081/wenjian/大赛作品评分标准.docx">下载文件</a></div>
      </div>
  </div>

    <list></list>

    <router-link to="/zhongxin"><qgengduo></qgengduo> </router-link>
    <bangdan></bangdan>

    <gonggao></gonggao>

    <botTom></botTom>

  </div>
</template>

<script>

import axios from "axios"
import list from "./List";
import bangdan from "./BangDan";
import gonggao from "./GongGao";
import botTom from "./BotTom";
import qgengduo from "./QgengDuo";

export default {
  name: "homepages",
  data() {
    return {
      bannerimgs:[]
    };
  },
  mounted:function(){

  this.onLoad();

  },
  methods:{
    onLoad(){
      axios({
  method:'get',
  url:this.$apiUrl+'/index.php/index/roll',
  headers: {'content-type': "application/json; charset=utf-8"},
  // timeout: 1000,
}).then(res=> {
this.bannerimgs = res.data.data;
}).catch(error =>{
    console.log(error);
})
}


  },
  components: {
    list,
    gonggao,
    botTom,
    bangdan,
    qgengduo,
  },
};
</script>

<style>
/* 中间的大图 */
/* .home-banner {
  margin-bottom: 20px;
} */
.banner-a {
  width: 100%;
  height: 6rem;
}
.banner-a>img{
  width: auto;
  height: 100%;
}

.xiazai {
  height: 214px;
  width: 100%;
  background: #FBFAFA;
opacity: 0.9;
display: flex;
justify-content:center;
}
.left {
  height: 180px;
  width: 10%;
  margin-right: 100px;
  margin-top: 20px;
  text-align: center;

}
.left p {
font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #020202;
}

/* .download { */
/* height: 34px;
background-color: #fff;
border-radius: 17px;
width: 82px;
margin: 0 auto;
text-align: center;
line-height: 34px;
border: 1px solid #0062e7; */

/* } */
.download a {
  display: block;
/* color: #fff; */
color: #0062E7;
height: 34px;
background-color: #fff;
border-radius: 17px;
width: 82px;
margin: 0 auto;
text-align: center;
line-height: 34px;
border: 1px solid #0062e7;


}
.download：hover {
/* background: #0062E7; */
background-color: #0062E7;

}
.download a：hover {
  color: #fff;
  background-color: #0062E7;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePages.vue